import "../../../resources/less/Family/ThemePages/FearAndFright.less";
import BaseThematique from "./BaseThematique";

class FearAndFright extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new FearAndFright();
});
